const formatOptionValue = (colId, isDesc) => {
    return `${colId}-${isDesc ? 'desc' : 'asc'}`;
};
export const a11y = {
    getAriaLiveTableHeader: (captionText, columnName, isSortedDesc) => {
        return `${captionText} sorted by ${columnName} in ${isSortedDesc ? 'descending' : 'ascending'} order`;
    },
};
export const visual = {
    getSortOptionsCardListHeader: (columns, ascString, descString) => {
        return columns.reduce((acc, col) => {
            if (!col.isSortable)
                return acc;
            const colHeader = typeof col.Header === 'string' ? col.Header : col.id;
            return [
                ...acc,
                {
                    label: `${colHeader} (${ascString})`,
                    value: `${formatOptionValue(col.id, false)}`,
                },
                {
                    label: `${colHeader} (${descString})`,
                    value: `${formatOptionValue(col.id, true)}`,
                },
            ];
        }, []);
    },
};
//# sourceMappingURL=strings.js.map